import React from "react";
import { Camera, CameraOptions } from "@ionic-native/camera";
import { Button } from "@material-ui/core";

export const StorageTest: React.FC = () => {
	const uploadImage = () => {
		const options: CameraOptions = {
			destinationType: Camera.DestinationType.DATA_URL,
			sourceType: Camera.PictureSourceType.SAVEDPHOTOALBUM,
		};
		Camera.getPicture(options).then(
			(imageData: any) => {
				// imageData is either a base64 encoded string or a file URI
				// If it's base64 (DATA_URL):
				console.error("getImageSuccess");
				// let base64Image = 'data:image/jpeg;base64,' + imageData;
			},
			(err: any) => {
				// Handle error
				console.error(err);
			}
		);
	};

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "space-between",
				alignItems: "center",
			}}
		>
			<Button
				style={{
					width: "20%",
					backgroundColor: "#43c5a6",
					color: "white",
					marginTop: 30,
				}}
				onClick={() => uploadImage()}
			>
				Upload Image
			</Button>
			{/* <Button
          style={{
            width: "20%",
            backgroundColor: "#d44336",
            color: "white",
            marginTop: 30,
          }}
          onClick={() => signInWithGoogle()}
        >
          Login with Gmail
        </Button>
        <Button
          style={{
            width: "20%",
            backgroundColor: "#3b5998",
            color: "white",
            marginTop: 30,
          }}
          onClick={() => signInWithFaceBook()}
        >
          Login with Facebook
        </Button>
        <Button
          style={{
            width: "20%",
            backgroundColor: "black",
            color: "white",
            marginTop: 30,
          }}
        >
          Login With Apple
        </Button>
        <Button
          onClick={() => signInAnonymously()}
          style={{
            width: "20%",
            backgroundColor: "pink",
            color: "white",
            marginTop: 30,
          }}
        >
          Login Anonymously
        </Button>
        <Button
          style={{
            width: "20%",
            backgroundColor: "#0876b7",
            color: "white",
            marginTop: 30,
          }}
          onClick={() => getIdToken()}
        >
          Generate Id Token
        </Button>
        <Button
          onClick={() => verifyIdToken()}
          style={{
            width: "20%",
            backgroundColor: "#0876b7",
            color: "white",
            marginTop: 30,
          }}
        >
          Verify Id Token
        </Button>
        <Button
          style={{
            width: "20%",
            backgroundColor: "#0876b7",
            color: "white",
            marginTop: 30,
          }}
          onClick={() => getIdToken(true)}
        >
          Generate Refresh Token
        </Button>
        <Button
          onClick={() => signOut()}
          style={{
            width: "20%",
            backgroundColor: "purple",
            color: "white",
            marginTop: 30,
          }}
        >
          Sign Out
        </Button> */}
		</div>
	);
};
